export const ResponseErrorCodes = {
  SESSION_TERMINATED: 163,
  TOKEN_EXPIRED: 105,
  SESSION_ENDED: 409
};
